/**
 * English: Build org/station query string for agent-management deep links.
 * Thai: สร้าง query string org/station สำหรับลิงก์ agent-management
 */
import { agentManagementQuery as buildAgentManagementQuery } from '../../hooks/useAgentManagementScope';

export { buildAgentManagementQuery as agentManagementQuery };

export function agentManagementPath(path: string, orgName: string, stationId: string): string {
  const base = path.startsWith('/') ? path : `/${path}`;
  return `${base}${buildAgentManagementQuery(orgName, stationId)}`;
}
